export enum KnownJsonTemplateTokens {
  VisaApplicationJson = "VisaApplicationJson",
}
